import { AppBar, Box, ListItemButton, styled, Toolbar } from "@mui/material";
import {
  colors,
  displayFlexAlignItemsCenterJustifyContentFlexStart,
  tokens,
} from "styles";

export const DRAWER_WIDTH = 290;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 120;

export const AppBarExt = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backgroundColor: colors.back21,
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
}));

export const ToolbarExt = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  backgroundColor: colors.back21,
  [theme.breakpoints.up("sm")]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 3),
  },
}));

export const ListItemBtnExt = styled((props) => (
  <ListItemButton disableGutters {...props} />
))(() => ({
  ...tokens.FS20FW400LH24R,
  position: "relative",
  textTransform: "capitalize",
  padding: "13px 20px",
  color: colors.whiteFF,
  gap: "0.5rem",
  borderRadius: "12px",
  marginBottom: "10px",
}));

export const ListItemContent = styled(Box)(() => ({
  ...displayFlexAlignItemsCenterJustifyContentFlexStart,
  gap: "15px",
}));
